export const GET_USERS =
    'src/modules/teams/GET_USERS';
export const CANCEL_ALL_API_REQUESTS =
    'src/modules/teams/CANCEL_ALL_API_REQUESTS';
export const APPLY_PAGINATION =
    'src/modules/teams/APPLY_PAGINATION';
export const APPLY_FILTERS =
    'src/modules/teams/APPLY_FILTERS';
export const RESET_FILTERS =
    'src/modules/teams/RESET_FILTERS';